import { ButtonComponent } from '@/components/commons'
import { IUser } from '@/interfaces/user'
import {
  useAcceptConnection,
  useDeclineConnection,
} from 'containers/profile-network/hooks/useConnectionsActions'
import { useProfile } from 'containers/profile/hooks/useProfile'
import { User } from 'containers/user/types/user'

interface AcceptDeclineButtonsProps {
  profile?: IUser | User
  showAccept?: boolean
  showDecline?: boolean
  buttonsClassName?: string
  onAccept?: () => void
  onDecline?: () => void
}

export const AcceptDeclineButtons = ({
  profile,
  showAccept = true,
  showDecline = true,
  onAccept,
  onDecline,
}: AcceptDeclineButtonsProps) => {
  const { profile: currentProfile } = useProfile()
  const { mutateAsync: acceptConnection, isLoading: acceptingConnection } =
    useAcceptConnection()
  const { mutateAsync: declineConnection, isLoading: decliningConnection } =
    useDeclineConnection()

  const profileId = profile?.id || currentProfile?.id

  const handleAcceptConnection = async () => {
    await acceptConnection({ userIdReceivedRequest: profileId })
    onAccept && onAccept()
  }

  const handleDeclineConnection = async () => {
    await declineConnection({ userIdReceivedRequest: profileId })
    onDecline && onDecline()
  }

  return (
    <>
      {showAccept && (
        <ButtonComponent
          size="xSmall"
          className="uppercase full-w"
          label="Accept"
          loading={acceptingConnection || decliningConnection}
          onClick={handleAcceptConnection}
        />
      )}
      {showDecline && (
        <ButtonComponent
          size="xSmall"
          variation="secondary"
          className="full-w uppercase"
          label="Ignore"
          loading={acceptingConnection || decliningConnection}
          onClick={handleDeclineConnection}
        />
      )}
    </>
  )
}
